import fetch from '../utils/fetch'

// 產地國家列表
export function getOrigincountry (query) {
  return fetch({
    url: '/crossborder/origincountry',
    method: 'get',
    params: query
  })
}

// 產地國家新增
export function addOrigincountry (query) {
  return fetch({
    url: '/crossborder/origincountry',
    method: 'post',
    params: query
  })
}

// 產地國家修改
export function updateOrigincountry (origincountry_id, query) {
  return fetch({
    url: '/crossborder/origincountry/' + origincountry_id,
    method: 'put',
    params: query
  })
}

// 產地國家刪除
export function delOrigincountry (origincountry_id, query) {
  return fetch({
    url: '/crossborder/origincountry/' + origincountry_id,
    method: 'delete',
    params: query
  })
}

// 獲取跨境設定
export function getCrossborderSet (query) {
  return fetch({
    url: '/crossborder/set',
    method: 'get',
    params: query
  })
}

// 儲存跨境設定
export function saveCrossborderSet (query) {
  return fetch({
    url: '/crossborder/set',
    method: 'post',
    params: query
  })
}

// 稅費策略列表獲取
export function getTaxstrategyList (query) {
  return fetch({
    url: '/crossborder/taxstrategy',
    method: 'get',
    params: query
  })
}

// 稅費策略詳情獲取
export function getTaxstrategyInfo (taxstrategy_id, query) {
  return fetch({
    url: '/crossborder/taxstrategy/' + taxstrategy_id,
    method: 'get',
    params: query
  })
}

// 稅費策略新增
export function addTaxstrategy (query) {
  return fetch({
    url: '/crossborder/taxstrategy',
    method: 'post',
    params: query
  })
}

// 稅費策略修改
export function updateTaxstrategy (taxstrategy_id, query) {
  return fetch({
    url: '/crossborder/taxstrategy/' + taxstrategy_id,
    method: 'put',
    params: query
  })
}

// 稅費策略刪除
export function delTaxstrategy (taxstrategy_id, query) {
  return fetch({
    url: '/crossborder/taxstrategy/' + taxstrategy_id,
    method: 'delete',
    params: query
  })
}
